import { ArrowLeftOutlined } from "@ant-design/icons";
import React from "react";
import { useHistory } from "react-router-dom";
import { LandingTitle } from "../../lib/styles/styleLibrary";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import PropTypes from "prop-types";

const PageTitleNavigation = ({
	title,
	showBack,
	handleBackButton,
	className,
	children,
}) => {
	const history = useHistory();
	return (
		<>
			{showBack ? (
				<div className={className}>
					<div
						tw="inline-flex flex-nowrap items-center gap-2 hover:cursor-pointer mb-4"
						onClick={() => {
							handleBackButton
								? handleBackButton()
								: history.goBack();
						}}>
						<ArrowLeftOutlined tw="px-2 py-2 bg-gray-100 rounded-full hover:bg-white" />
						<LandingTitle tw="text-lg md:text-2xl font-bold leading-8 m-0! whitespace-pre">
							{title}
						</LandingTitle>
					</div>
					{children}
				</div>
			) : (
				<div
					className={className}
					tw="inline-flex flex-nowrap items-center gap-2 hover:cursor-pointer mb-4">
					<LandingTitle tw="text-lg md:text-2xl font-bold leading-8 m-0! whitespace-pre">
						{title}
					</LandingTitle>
					{children}
				</div>
			)}
		</>
	);
};

PageTitleNavigation.propTypes = {
	name: PropTypes.string,
	showBack: PropTypes.bool,
	handleBackButton: PropTypes.func,
};

PageTitleNavigation.defaultProps = {
	name: "Stranger",
	showBack: false,
};

export default PageTitleNavigation;
